// src/components/quality/DynamicsCriteriaTable.js

import {Fragment} from "react";

const DynamicsCriteriaTable = ({ assessmentsByWeek, criteria, periodType }) => {
  // Извлекаем периоды из assessmentsByWeek (ключи объекта - это метки периодов)
  const periods = Object.keys(assessmentsByWeek).map(label => ({
    label,
    data: assessmentsByWeek[label] || []
  }));
  
  // Сортируем периоды в обратном порядке (от новых к старым)
  const sortedPeriods = periods.reverse().slice(0, 6);
  
  // Формируем данные: критерий -> период -> массив items с score === 0
  const data = {};
  
  // Инициализируем структуру данных для каждого критерия
  criteria.forEach(criterion => {
    data[criterion.name] = {};
    
    // Инициализируем каждый период для каждого критерия
    periods.forEach(period => {
      data[criterion.name][period.label] = [];
    });
  });
  
  // Распределяем оценки по критериям и периодам
  periods.forEach(period => {
    const periodLabel = period.label;
    
    period.data.forEach(assessment => {
      if (assessment.items && Array.isArray(assessment.items)) {
        // Проходим по каждому критерию в оценке
        assessment.items.forEach(item => {
          // Находим соответствующий критерий по id
          const criterion = criteria.find(c => c.id === item.criteria_id);
          if (criterion && item.score === 0) {
            // Добавляем оценку в данные для этого критерия и периода
            if (data[criterion.name] && data[criterion.name][periodLabel]) {
              data[criterion.name][periodLabel].push(item);
            }
          }
        });
      }
    });
  });
  
  // Предварительно считаем общее количество ошибок по каждому периоду (по всем критериям)
  const totalByPeriod = {};
  sortedPeriods.forEach(period => {
    const periodLabel = period.label;
    totalByPeriod[periodLabel] = 0;
    Object.values(data).forEach(criterionData => {
      totalByPeriod[periodLabel] += (criterionData[periodLabel] || []).length;
    });
  });

  return (
    <div className="table-wrapper" style={{ overflowX: 'auto' }}>
      <h3>Статистика по критериям</h3>
      <table className="stats-table" style={{ minWidth: '800px' }}>
        <thead>
        <tr>
          <th rowSpan="2" style={{ position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 2 }}>Критерии</th>
          <th rowSpan="2">Динамика</th>
          {sortedPeriods.map((period, index) => (
              <Fragment key={index}>
                <th colSpan="2">{period.label}</th>
              </Fragment>
          ))}
        </tr>
        <tr>
          {sortedPeriods.map((period, index) => (
              <Fragment key={index}>
                <th>Количество ошибок</th>
                <th>% ошибок</th>
              </Fragment>
          ))}
        </tr>
        </thead>
        <tbody>
          {criteria.map(criterion => {
            const criterionName = criterion.name;
            const periodsData = data[criterionName] || {};

            // --- Логика динамики: изменение доли критерия в общем количестве ---
            const firstPeriodLabel = sortedPeriods.length > 0 ? sortedPeriods[0].label : '';
            const secondPeriodLabel = sortedPeriods.length > 1 ? sortedPeriods[1].label : '';

            const firstTotal = (periodsData[firstPeriodLabel] || []).length;
            const secondTotal = (periodsData[secondPeriodLabel] || []).length;

            const firstTotalAll = totalByPeriod[firstPeriodLabel] || 1;
            const secondTotalAll = totalByPeriod[secondPeriodLabel] || 1;

            const firstShare = (firstTotal / firstTotalAll) * 100;
            const secondShare = (secondTotal / secondTotalAll) * 100;

            let diffText = '';
            let diffColor = '';
            if (firstTotal > 0 && secondTotal > 0) {
              const diffPercent = firstShare - secondShare;
              const absDiff = Math.round(Math.abs(diffPercent));
              if (diffPercent < 0) {
                diffText = `▼${absDiff}%`;
                diffColor = 'red';
              } else if (diffPercent > 0) {
                diffText = `▲${absDiff}%`;
                diffColor = 'green';
              } else {
                diffText = `▲0%`;
                diffColor = 'green';
              }
            }
            // --- Конец логики динамики ---

            return (
              <tr key={criterionName}>
                <td style={{ position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>{criterionName}</td>
                <td style={{ color: diffColor, fontWeight: 'bold' }}>{diffText}</td>
                {sortedPeriods.map(period => {
                  const periodLabel = period.label;
                  const periodItems = periodsData[periodLabel] || [];
                  const totalInPeriod = totalByPeriod[periodLabel] || 1;
                  const percent = totalInPeriod > 0 ? ((periodItems.length / totalInPeriod) * 100).toFixed(1) : '';

                  return [
                    <td key={`${criterionName}-total-${periodLabel}`}>{periodItems.length > 0 ? periodItems.length : ''}</td>,
                    <td key={`${criterionName}-percent-${periodLabel}`}>
                      {periodItems.length > 0 ? `${percent}%` : ''}
                    </td>
                  ];
                })}
              </tr>
            );
          })}
        </tbody>
        <tfoot>
        <tr>
          <td style={{ position: 'sticky', left: 0, backgroundColor: 'white', fontWeight: 'bold', zIndex: 1 }}>Всего</td>
          <td></td>
          {sortedPeriods.map(period => {
            const periodLabel = period.label;
            const total = totalByPeriod[periodLabel] || 0;
            return [
              <td key={`total-${periodLabel}`}>{total}</td>,
              <td key={`total-pct-${periodLabel}`}></td>
            ];
          })}
        </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default DynamicsCriteriaTable;
